module.exports = __webpack_public_path__ + "static/media/cts_image3.58d38113.png";